// import { useSelector } from 'react-redux';
// import Loading from '../../reusableElementsComponents/Loading';

function DesktopAuthDecoration({illustration}) {
    // const data = useSelector( state => state.contentfulData.all['Auth desktop decoration']);

    return (
        <div className="d-none d-lg-block col-lg-6 p-0 auth-desktop-decoration">
            <div className="decoration-wrapper">
                {illustration ? (
                    <div className="illustration-wrapper">
                        <img className="illustration" src={illustration} alt="login" />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default DesktopAuthDecoration;
